import React, { useCallback, useEffect, useState } from 'react';

import {
    AchatsAppDispatch,
    FACTURES_ACHATS_SLICE_NAME,
    factureAchatsFiltersToElasticQuery,
    useAchatsService,
    useSociete,
} from '@europrocurement/l2d-domain';
import { toSyncInvoiceIcon } from '@europrocurement/l2d-icons';
import { Grid } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import achatsViewPathResolver from '../../../../Achats/achatsViewPathResolver';
import WidgetWithAction from './components/WidgetWithAction';

// interne

const FacturesASynchroniser: React.FunctionComponent = function () {
    const dispatch = useDispatch<AchatsAppDispatch>();
    const navigate = useNavigate();

    const { factureAchatApi, getFactureAchat } = useAchatsService();

    const xIdSociete = useSociete();

    const [countOfInvoicesToSynchronise, setCountOfInvoicesToSynchronise] = useState<string>();

    useEffect(() => {
        factureAchatApi
            .getFacturesAchatsFactureAchatCollection(
                factureAchatsFiltersToElasticQuery({
                    xIdSociete,
                    search: '',
                    orders: [],
                    pagination: {
                        page: 0,
                        itemsPerPage: 0,
                    },
                    filters: {
                        cloture: true,
                        syncG3: false,
                        deleted: false,
                    },
                }),
            )
            .then((res) => {
                if (
                    res.data['hydra:totalItems'] !== null ||
                    res.data['hydra:totalItems'] !== undefined
                ) {
                    setCountOfInvoicesToSynchronise(`${res.data['hydra:totalItems']}`);
                }
            });
    }, [factureAchatApi, xIdSociete]);

    const clearPreviousFilters = useCallback(() => {
        dispatch({
            type: `${FACTURES_ACHATS_SLICE_NAME}/resetmainFilter`,
        });
    }, [dispatch]);

    const applyFilters = useCallback(() => {
        dispatch({
            type: `${FACTURES_ACHATS_SLICE_NAME}/resetMainFilters`,
        });

        dispatch({
            type: `${FACTURES_ACHATS_SLICE_NAME}/setmainFilter`,
            payload: {
                key: 'syncG3',
                value: false,
            },
        });
    }, [dispatch]);

    const beforeActionCallback = useCallback(() => {
        clearPreviousFilters();
        applyFilters();
    }, [applyFilters, clearPreviousFilters]);

    const actionCallback = useCallback(async () => {
        await dispatch(getFactureAchat({}));
    }, [dispatch, getFactureAchat]);

    const onActionSuccessCallback = useCallback(() => {
        navigate(achatsViewPathResolver('listfacture'));
    }, [navigate]);

    return (
        <Grid
            sx={{
                flex: 1,
            }}
            item
            lg={1}
            md={1}
            xs={12}
        >
            <WidgetWithAction
                title="Factures à synchroniser"
                icon={toSyncInvoiceIcon}
                actionMessage="Consulter"
                actionCallback={actionCallback}
                data={countOfInvoicesToSynchronise}
                paragraph="Factures à synchroniser avec G3 :"
                color="primary"
                loadingMessage="Application des filtres..."
                beforeActionCallback={beforeActionCallback}
                onActionSuccessCallback={onActionSuccessCallback}
            />
        </Grid>
    );
};

export default FacturesASynchroniser;
